export default {
  en: {
    'NO_ITEMS': 'No options',
    'NO_FILTERED_ITEMS': 'No results'
  }
};